import { Routes } from '@angular/router';
import { oauthAuthenticationGuard, oauthCanMatch } from '@techniek-team/oauth';

export const ROUTES: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@school-dashboard/login').then((c) => c.LoginPage),
    data: { preload: false },
  },
  {
    path: 'geen-toegang',
    loadComponent: () => import('@school-dashboard/forbidden').then((c) => c.ForbiddenPage),
    data: { preload: false },
  },
  {
    path: 'niet-gevonden',
    loadComponent: () => import('@school-dashboard/not-found').then((m) => m.NotFoundComponent),
    data: { preload: false },
  },
  {
    path: '',
    canMatch: [oauthCanMatch],
    canActivate: [oauthAuthenticationGuard],
    loadChildren: () => import('./app/app.routing').then((m) => m.ROUTES),
    data: { preload: false },
  },
  /** Angular go through the routes in ascending order. The Child routing of {@link ./app/app.routing} will be loaded first
   * if the user is authenticated. This routing contains a redirect to `/niet-gevonden` on all not matching routes.
   * which means that when Angular comes to this `**` route, it will redirect to the `login` route.
   */
  {
    path: '**',
    redirectTo: 'login',
    data: { preload: false },
  },
];
